<template>
  <div>
    <div class="search-bar-body">
<!--      <div class="search-bar">
        <div class="search-title-body">
          <div class="search-title">
            提取
          </div>
          <div class="vip-bar">
            <div class="vip">
              <img src="@/assets/ic_vip.png" alt="" />
            </div>
            <div class="vip-tip">
              无限次生效中
            </div>
          </div>
        </div>
        <div class="command-body">
          <input type="text" placeholder="输入口令提取文件" @keyup.enter="handleEnter" v-model="inputValue">
        </div>
      </div> -->
    </div>
    <div class="extract-body">
      <div class="extract-content">
        <div class="file-step-arr" ref="stepContainer">
          <div class="file-step-scroll">
            <div class="file-step-item" v-for="(item, index) in gradeList" :key="index" @click="goBackStep(index)">
              <div class="file-step-item-title">{{ item.title }}</div>
              <img src="@/assets/ic_right.png" alt="" />
            </div>
            <div class="file-stop-last" :class="{'file-stop-last-active': gradeList.length == 0}">{{ currentDir.title }}</div>
          </div>
        </div>
        <!-- <div class="file-back" @click="goBack" v-if="gradeList.length > 0">
          <div class="ic">
            <img src="@/assets/ic_back.png" alt="" />
          </div>
          <div>返回</div>
        </div> -->
      </div>
      <div class="extract" ref="scrollContainer" v-if="currentDir.subs.length > 0">
        <file-item @click.native="clickFileItem(item)" :file-item="item" :showCkeakBtn="false" v-for="(item, index) in currentDir.subs" :key="index"></file-item>
      </div>
      <div ref="scrollContainer" v-else>
        <empty></empty>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { diskCodeLogs, diskCodeViews, diskIndex } from '@/utils/api/apis.js'
  import fileItem from '../file_item.vue'
  import { throttle } from 'lodash';
  import empty from '@/components/empty.vue';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      fileItem,
      empty
    },
    data() {
      // 这里存放数据
      return {
        lastScrollTop: 0,
        inputValue: '',
        formData: {
          page: 1,
          pagesize: 20,
          dir_id: 0
        },
        currentDir: {
          title: '提取记录',
          subs: [],
          total: 0
        },
        gradeList: []
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 加载更多
      handleScroll: throttle(function () {
        const container = this.$refs.scrollContainer;
        const scrollTop = container.scrollTop;
        // 检查是否滚动到底部，且滚动方向是向下
        if (scrollTop > this.lastScrollTop && scrollTop + container.clientHeight >= container.scrollHeight) {
          if (this.currentDir.total <= this.currentDir.subs.length) return;
          this.formData.page++;
          if (this.gradeList.length > 0) {
             this.getDiskIndex()
          } else {
            this.getDiskCodeLogs();
          }
        }
        this.lastScrollTop = scrollTop;
      }, 100),
      async getDiskCodeLogs() {
        try{
          var base = await diskCodeLogs(this.formData);
          if (this.formData.page == 1) {

            this.currentDir.subs = base.data.list
            this.currentDir.total = base.data.total
          } else {
            this.currentDir.subs = this.currentDir.subs.concat(base.data.list)
          }
        }catch(e){
          this.$toast(e)
          if (this.formData.page > 1) {
            this.formData.page--
          }
          this.$errorLog('tab_command/getDiskCodeLogs', e)
        }
      },
      // async clickFileItem(item) {
      //   if (item.is_dir != 1) {
      //     return;
      //   }
      //   // 记录当前层级的文件夹信息，便于返回上一级
      //   this.gradeList.push({
      //     ...this.currentDir,
      //     page: this.formData.page,// 将当前页码记录
      //     scrollTop: this.lastScrollTop
      //   });

      //   this.currentDir.title = item.title
      //   // 更新目录ID并重新请求数据
      //   this.formData.dir_id = item.id;
      //   this.formData.page = 1; // 重新加载时从第一页开始
      //   // 滚动回顶部
      //   this.$nextTick(() => {
      //     this.$refs.scrollContainer.scrollTop = 0;
      //   });
      //   this.getDiskIndex()
      // },
      async clickFileItem(item) {
        if (item.is_dir != 1) {
          return;
        }
        this.$dialog.loading.show()
        try {
          // 保存当前的 dir_id，用于请求新数据
          const newDirId = item.id;
          // 先尝试获取新目录的数据
          const tempFormData = { ...this.formData, dir_id: newDirId, page: 1 };
          var base = await diskIndex(tempFormData);
          this.$dialog.loading.hide()
          
          // 数据获取成功后，再更新导航状态
          this.gradeList.push({
            ...this.currentDir,
            page: this.formData.page,
            scrollTop: this.lastScrollTop
          });

          // 更新当前目录信息
          this.currentDir.title = item.title;
          this.formData.dir_id = newDirId;
          this.formData.page = 1;

          // 更新数据和滚动位置
          base.data.list.forEach((item) => {
            if (item.data_type != 3) {
              item.selected = this.selectedAll
            }
          });
          this.currentDir.subs = base.data.list;
          this.currentDir.total = base.data.total;

          this.$nextTick(() => {
            this.$refs.scrollContainer.scrollTop = 0;
          });
        } catch(e) {
          this.$dialog.loading.hide()
          this.$toast(e);
          this.$errorLog('tab_command/clickFileItem', e);
        }
      },
      // 返回上一级目录
      async goBack() {
        if (this.gradeList.length > 0) {
          // 从 gradeList 中弹出上一级数据
          const previousDir = this.gradeList.pop();
          // 设置为上一级目录并更新dir_id
          this.currentDir = previousDir;
          this.formData.page = previousDir.page;
          this.formData.dir_id = previousDir.id || 0;
          // 恢复滚动位置
          this.$nextTick(() => {
            this.$refs.scrollContainer.scrollTop = previousDir.scrollTop || 0;
          });
        }
      },
      async getDiskIndex() {
        try{
          var base = await diskIndex(this.formData);
          base.data.list.forEach((item) => {
            if (item.data_type != 3) {
              item.selected = this.selectedAll
            }
          });
          if (this.formData.page == 1) {

            this.currentDir.subs = base.data.list
            this.currentDir.total = base.data.total
          } else {
            this.currentDir.subs = this.currentDir.subs.concat(base.data.list)
          }
        }catch(e){
          this.$toast(e)
          if (this.formData.page > 1) {
            this.formData.page--
          }
          this.$errorLog('tab_command/getDiskIndex', e)
        }
      },
      async handleEnter() {
        if (!this.inputValue.trim()) {
          return;
        }
        try{
          var base = await diskCodeViews({
            code: this.inputValue.trim(),
            dir_id: 0
          })
        }catch(e){
          this.$toast(e)
          this.$errorLog('tab_command/handleEnter', e)
        }
      },
      goBackStep(index) {
        // 获取指定索引的目录数据
        const previousDir = this.gradeList[index];
        // 清除该索引及之后的数据
        this.gradeList = this.gradeList.slice(0, index);
        // 设置为上一级目录并更新dir_id
        this.currentDir = previousDir;
        this.formData.page = previousDir.page;
        this.formData.dir_id = previousDir.id || 0;
        // 恢复滚动位置
        this.$nextTick(() => {
          this.$refs.scrollContainer.scrollTop = previousDir.scrollTop || 0;
        });
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
      this.getDiskCodeLogs()
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .search-bar-body {
    padding: 0 24px;
    .search-bar {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      height: 142px;
      border-bottom: 1px solid #EEEEEE;
      .search-title-body {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .search-title {
          font-size: 15px;
          font-weight: bold;
          margin-right: 41px;
        }
        .vip-bar {
          display: flex;
          align-items: center;
          .vip {
            width: 20px;
            height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;
            img {
              width: 20px;
              height: 12px;
            }
          }
          .vip-tip {
            font-size: 11px;
            color: #E77700;
          }
        }
      }
      .command-body {
        border: 0.5px solid #444444;
        border-radius: 14px;
        padding: 0 16px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 402px;
        background-color: #FAFAFA;
        box-shadow: 0px 4px 7px 0px rgba(68,68,68,0.1);
        input {
          width: 100%;
          background-color: #FAFAFA;
        }
      }
    }
  }
  .extract-body {
    .extract-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      height: 64px;
      max-width: 100%;
      .file-step-arr {
        position: relative; // 添加相对定位
        flex: 1;
        width: 0; // 关键：添加width: 0确保flex-basis为0
        min-width: 0; // 关键属性：允许flex子项收缩到比其内容更小
        overflow-x: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        
        .file-step-scroll {
          display: flex;
          align-items: center;
          min-width: min-content; // 确保内容不会被压缩
          padding-right: 16px; // 为最后一项添加一些右边距
        }
        .file-step-item {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: bold;
          color: #000;
          .file-step-item-title {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          cursor: pointer;
          img {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
          }
        }
        .file-step-item:first-child{
          font-size: 18px;
        }
        .file-stop-last {
          font-size: 15px;
          font-weight: bold;
          color: rgba(153, 153, 153, 1);
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .file-stop-last-active {
          font-size: 18px;
        }
      }
      .extract-title {
        font-size: 15px;
        font-weight: bold;
        height: 60px;
        display: flex;
        align-items: center;
      }
      .file-back {
        display: flex;
        align-items: center;
        .ic {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          /* margin-right: 12px; */
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    .extract {
      /* height: calc(100vh - 373px); */
      height: calc(100vh - 260px);
      overflow-y: auto;
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/tab_command.vue